

















































































































































































import {Component, Mixins, Prop, PropSync, Watch} from 'vue-property-decorator';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin';
import {
  AdditionalPayType,
  ClaimClassType,
  ClaimStatusType,
  RefundBankAccount,
  RefundType,
  SelectListItem
} from '@/types/claim';
import {
  isCancelExchange,
  isReturnExchange,
  isExchangeDonePayDone,
  isExchangeProcRequestPay,
  isExchangeProcRequestRefund
} from '@/components/claim/popup/validations';
import {namespace} from 'vuex-class';
import {BankAccount, GetMallsMallNoRequest, MallDetail} from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';

const mallModule = namespace('mall');
/**
 * 매우 복잡함. 반드시 기획서 '교환처리금액' 파트 보기
 * '추가결제' 상황과, '환불'해야하는 상황 2가지로 나뉜다.
 * 추가결제 판단: additionalPay의 값이 0이 아님
 *  - 무통장 입금
 *  - 적립금 차감
 *
 * 환불 판단 : adjustedAmounts.payAmt가 0이 아님
 */

//TODO: 구조개선
@Component({
  components: {CompSelectBox},
  computed: {
    isCancelExchange,
    isReturnExchange,
    isExchangeDonePayDone,
    isExchangeProcRequestPay,
    isExchangeProcRequestRefund,
    // TODO: claimNo: 38912 의 경우 additionalPayType과 displayRefundType 둘 다 존재함. 문의드리기
    isRefund(): boolean {
      return !!this.claimNoResponseData.displayRefundType
    },
    isAdditionalPay(): boolean {
      return !!this.claimNoResponseData.additionalPayType
    },
    isAccountRefundType(){
      return this.refundTypeSync === RefundType.ACCOUNT
    },
    redHighlight(): string{
      return this.claimNoResponseData.claimClassType === ClaimClassType.RETURN_EXCHANGE ? 'red' : ''
    },
    hasRefundAccount(){
      return Boolean(this.refundBankAccountSync?.account)
    },
    isPG(){
      return this.claimNoResponseData.pgType !== 'NONE'
    },
    isVirtualAccount(){
      // 교환클레임은 클레임 수정 불가. 그래서 originalPayType만으로 체크가능
      return this.claimNoResponseData.originalPayType === 'VIRTUAL_ACCOUNT';
    },
    showRefundAccount(){
      return (this.isPG && this.isVirtualAccount && this.hasRefundAccount) || (!this.isPG && this.hasRefundAccount)
    },
  }
})
export default class ExchangeProcessAmount extends Mixins(AmountMixin){
  @mallModule.Getter('mallDetail') private mallDetail!: MallDetail
  @mallModule.Action('fetchMallsMallNo') private fetchMallsMallNo!: (request: GetMallsMallNoRequest) => Promise<void>;

  @Prop({required: true})
  private claimStatusType!: ClaimStatusType
  @PropSync('refundType')
  private refundTypeSync!: RefundType
  @PropSync('refundBankAccount')
  private refundBankAccountSync!: RefundBankAccount
  @PropSync('additionalPayBankAccount')
  private additionalPayBankAccountSync!: BankAccount
  @PropSync('additionalPayRemitter')
  private additionalPayRemitterSync!: string

  private tradeBank = ''
  private tradeBankSelectList: SelectListItem[] = []
  private refundTypeSelectList: SelectListItem[] = []
  private refundBankList: SelectListItem[] = []

  @Watch('tradeBank')
  private setAdditionalPayBankAccount(){
    const selectedBank = this.mallDetail?.tradeBanks.find(tradeBank => tradeBank.bankAccount === this.tradeBank)
    const {
      bank,
      bankName,
      bankAccount: account,
      bankDepositorName: depositorName
    } = selectedBank

    this.additionalPayBankAccountSync = {
      bank,
      bankName,
      account,
      depositorName
    }
  }


  private get additionalPayType(): AdditionalPayType | ''{
    if(!this.claimNoResponseData.additionalPayType){
      return ''
    }

    return AdditionalPayType[this.claimNoResponseData.additionalPayType]
  }

  async created(){
    const request: GetMallsMallNoRequest = {pathParams: {mallNo: this.claimNoResponseData.mallNo.toString()}}
    await this.fetchMallsMallNo(request)
    await this.fetchAndSetRefundBankList()
    this.setTradeBankSelectList()
    this.resetRefundTypeSelectList()
  }

  private async fetchAndSetRefundBankList(){
    const banksResponse = await this.$api.getBanks({params: { countryCode: 'KR'}})
    this.refundBankList = banksResponse.data.filter(bank => bank.value !== 'ANONYMOUS')
  }

  private setTradeBankSelectList(){
    this.tradeBankSelectList = this.mallDetail?.tradeBanks.map(tradeBank => (
      {
        value: tradeBank.bankAccount,
        name: `${tradeBank.bankAccount} / ${tradeBank.bank} (${this.$t('CLAIM_POPUP_DEPOSITOR_NAME')} : ${tradeBank.bankDepositorName} )`
      }
    ))
    this.tradeBank = this.additionalPayBankAccountSync.account
  }

  private changeRefundAccountBankName(){
    const selectedBank = this.refundBankList.find(refundBank => refundBank.value === this.refundBankAccountSync.bank)
    this.refundBankAccountSync.bankName = selectedBank.name
  }

  private resetRefundTypeSelectList(){
    const {pgType, originalPayTypeLabel} = this.claimNoResponseData;
    this.refundTypeSelectList = this.generateRefundTypeSelectList(this.amounts.adjustedAmounts, pgType, originalPayTypeLabel);
    return
  }
}
